import tw from 'tailwind-styled-components'
import {LinkHandle} from '@components/timeline-new/diagram/graph/link-handle'
import {cn} from '@containers/html-utils'

export const TwSwimlanes = tw.div`
  overflow-hidden
  min-h-0
  min-w-0
`

export const TwContainer = tw.div`
  relative
  isolate
  min-h-full
  w-full
`

export const TwSwimlane = tw.div<{$hovered?: boolean}>`
  group/swimlane
  absolute
  h-40
  w-full
  shadow-border-b-1
  shadow-line-base
  -z-10
  ${p => cn(p.$hovered && 'bg-background-hover')}
`

export const TwContainerBox = tw.div`
  pointer-events-auto

  absolute
  h-8
  rounded-2
  z-30
  bg-normal-blue
  before:content-['']
  before:absolute
  before:top-0
  before:left-0
  before:w-0
  before:h-0
  before:border-solid
  before:border-t-[12px]
  before:border-r-[12px]
  before:border-b-0
  before:border-l-0
  before:border-t-inherit
  before:border-r-transparent
  before:border-b-transparent
  before:border-l-transparent

  after:content-['']
  after:absolute
  after:top-0
  after:right-0
  after:w-0
  after:h-0
  after:border-solid
  after:border-t-0
  after:border-r-[12px]
  after:border-b-[12px]
  after:border-l-0
  after:border-t-transparent
  after:border-r-inherit
  after:border-b-transparent
  after:border-l-transparent
`

export const TwTaskBoxPlaceholder = tw.div`
  pointer-events-none
  absolute
  rounded-4
  border-dashed
  border-1
  border-action-default
  
  after:content-['']
  after:absolute
  after:top-0
  after:bottom-0
  after:left-0
  after:right-0
  after:bg-background-secondary
  after:opacity-60
`

// before contains valid shadow for dragging, after is used for hover detection
export const TwTaskBoxContainer = tw.div<{
  $subtask?: boolean
  $draggable?: boolean
  $dragging?: boolean
  $linking?: boolean
  $linkingSelf?: boolean
  $hoverable?: boolean
}>`
  pointer-events-auto
  group/task-box
  absolute
  isolate
  rounded-4
  flex
  items-center
  z-30
  before:content-[""]
  before:absolute
  before:rounded-4
  before:top-0
  before:bottom-0
  before:-left-8
  before:-right-8
  before:-z-10
  after:content-[""]
  after:absolute
  after:top-0
  after:bottom-0
  after:-left-8
  after:-right-[20px]
  after:-z-10
  ${p =>
    cn(
      p.$subtask ? 'h-16' : 'h-24',
      p.$draggable && p.$dragging && 'before:shadow-lg',
      p.$hoverable && 'hover:z-1000',
      p.$linking && 'before:hidden after:hidden',
      p.$linking && !p.$linkingSelf && 'hover:shadow-lg'
    )}
`

export const TwTaskBox = tw.div<{
  $completed?: boolean
  $draggable?: boolean
  $dragging?: boolean
  $linking?: boolean
  $hoverable?: boolean
  $canDragStart?: boolean
  $canDragEnd?: boolean
}>`
  absolute
  top-0
  bottom-0
  left-0
  right-0
  rounded-4
  ${p =>
    cn(
      p.$completed && 'bg-background-active shadow-border-1 shadow-line-base',
      p.$dragging && p.$canDragStart && '!rounded-l-none',
      p.$dragging && p.$canDragEnd && '!rounded-r-none',
      p.$draggable && !p.$dragging && !p.$linking && 'cursor-grab',
      p.$hoverable &&
        p.$canDragStart &&
        'hover:rounded-l-none group-hover/task-box:rounded-l-none',
      p.$hoverable &&
        p.$canDragEnd &&
        'hover:rounded-r-none group-hover/task-box:rounded-r-none'
    )}
`

const TwBoxBorderHandle = tw.div`
  hidden
  group-hover/task-box:block
  absolute
  w-8
  top-0
  bottom-0
  bg-background-hover
  cursor-ew-resize
  z-10
  shadow-line-hover
  before:content-[""]
  before:absolute
  before:top-6
  before:bottom-6
  before:w-1
  before:rounded-full
  before:bg-line-hover
  after:content-[""]
  after:absolute
  after:top-6
  after:bottom-6
  after:w-1
  after:rounded-full
  after:bg-line-hover
`

export const TwLeftHandle = tw(TwBoxBorderHandle)<{
  $visible?: boolean
  $hidden?: boolean
  $interactable?: boolean
}>`
  left-0
  shadow-border-blt-1
  rounded-l-4
  -translate-x-full
  before:left-[3px]
  after:left-[5px]
  ${p =>
    cn(
      p.$visible && '!block',
      p.$hidden && '!hidden',
      !p.$interactable && 'pointer-events-none'
    )}
`

export const TwRightHandle = tw(TwBoxBorderHandle)<{
  $visible?: boolean
  $hidden?: boolean
  $interactable?: boolean
}>`
  right-0
  shadow-border-trb-1
  rounded-r-4
  translate-x-full
  before:right-[3px]
  after:right-[5px]
  ${p =>
    cn(
      p.$visible && '!block',
      p.$hidden && '!hidden',
      !p.$interactable && 'pointer-events-none'
    )}
`

export const TwLinkHandle = tw(LinkHandle)<{
  $visible?: boolean
  $hidden?: boolean
  $interactable?: boolean
}>`
  hidden
  group-hover/task-box:block
  absolute
  right-[-18px]
  ${p =>
    cn(
      p.$visible && '!block',
      p.$hidden && '!hidden',
      !p.$interactable && 'pointer-events-none'
    )}
`
